module.exports = __webpack_public_path__ + "static/media/sombra-interna-miolo-direito.9b31429b.svg";